<template>
	<span class="inline-flex items-center gap-1" :class="wrapperClass">
		<span>{{ label }}</span>
		<span v-if="required" class="text-red-500">*</span>
		<i
			v-if="tooltip"
			class="pi pi-question-circle text-primary cursor-help shrink-0"
			:class="iconClass"
			v-tooltip.top="tooltipConfig"
			@click.stop.prevent
			@mousedown.stop.prevent
			@pointerdown.stop
		/>
	</span>
</template>

<script lang="ts" setup>
import { computed } from "vue"

const props = withDefaults(
	defineProps<{
		label: string
		tooltip?: string
		required?: boolean
		/** Extra classes for the outer flex wrapper */
		wrapperClass?: string
		/** Extra classes for the help icon (e.g. text-sm / text-xl) */
		iconClass?: string
	}>(),
	{
		tooltip: "",
		required: false,
		wrapperClass: "",
		iconClass: "text-sm",
	}
)

const tooltipConfig = computed(() => {
	if (!props.tooltip) return ""
	return {
		value: props.tooltip,
		showDelay: 200,
		hideDelay: 0,
		tooltipStyleClass: "max-w-md whitespace-normal break-words",
	}
})
</script>
